import { useEffect } from 'react';
import { fetchRecentlyUpdatedTemplates, selectIsRecentlyUpdatedTemplatesRequestPending, selectRecentlyUpdatedTemplates } from '../redux/recentlyUpdatedTemplatesReducer';
import { RecentlyViewed } from './RecentlyViewed';
import { useDispatch, useSelector } from 'react-redux';
import { CONTENT_MARGIN_BOTTOM } from '../constants/styling';
import { Flex } from 'foundations-components/components/Flex';
import { MostPopularTemplates } from './MostPopularTemplates';
import { RecommendedTemplates } from './discover/RecommendedTemplates';
import { RecentlyUpdatedTemplates } from './discover/RecentlyUpdatedTemplates';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Discover = ({
  mostPopularTemplates
}) => {
  const dispatch = useDispatch();
  useEffect(() => {
    void dispatch(fetchRecentlyUpdatedTemplates());
  }, [dispatch]);
  const recentlyUpdatedTemplates = useSelector(selectRecentlyUpdatedTemplates);
  const loading = useSelector(selectIsRecentlyUpdatedTemplatesRequestPending);
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    gap: CONTENT_MARGIN_BOTTOM,
    children: [/*#__PURE__*/_jsx(RecentlyViewed, {}), /*#__PURE__*/_jsx(RecommendedTemplates, {}), mostPopularTemplates.length > 0 && /*#__PURE__*/_jsx(MostPopularTemplates, {
      templates: mostPopularTemplates
    }), !loading && recentlyUpdatedTemplates.length > 0 && /*#__PURE__*/_jsx(RecentlyUpdatedTemplates, {
      templates: recentlyUpdatedTemplates
    })]
  });
};